export default [
  {
    path: 'trade',
    name: 'trade',
    component: resolve => {
      require(['@/modules/UserCenter/Order'], resolve)
    },
    beforeEnter: (to, from, next) => {
      if (to.params.roleName === 'personal') {
        next()
      } else {
        next({path: '/'})
      }
    },
    children: [
      {
        path: 'orders/detail/:id',
        name: 'ordersdetail',
        component: resolve => {
          require(['@/modules/UserCenter/Order/Detail'], resolve)
        }
      },
      {
        path: 'orders/detailSimple/:id',
        name: 'orderdetailSimple',
        component: resolve => {
          require(['@/modules/UserCenter/Order/OrderDetailSimple'], resolve)
        }
      },
      {
        path: 'orders/modify/:id',
        name: 'ordersmodify',
        component: resolve => {
          require(['@/modules/UserCenter/Order/Modify'], resolve)
        }
      },
      {
        path: 'orders',
        name: 'orders',
        component: resolve => {
          require(['@/modules/UserCenter/Order/Orders'], resolve)
        }
      },
      {
        path: 'ordersSimple',
        name: 'ordersSimple',
        component: resolve => {
          require(['@/modules/UserCenter/Order/OrdersSimple'], resolve)
        }
      },
      {
        path: 'refund',
        name: 'refund',
        component: resolve => {
          require(['@/modules/UserCenter/Order/Refund'], resolve)
        }
      },
      {
        path: 'refund/detail/:id',
        name: 'refunddetail',
        component: resolve => {
          require(['@/modules/UserCenter/Order/Detail'], resolve)
        }
      }
    ],
    redirect: 'trade/orders'
  },
  {
    path: 'markets',
    name: 'markets',
    component: resolve => {
      require(['@/modules/UserCenter/Order'], resolve)
    },
    children: [
      {
        path: 'marketsorders',
        name: 'marketsorders',
        component: resolve => {
          require(['@/modules/UserCenter/Order/MarketsOrders'], resolve)
        }
      },
      {
        path: 'marketsrefund',
        name: 'marketsrefund',
        component: resolve => {
          require(['@/modules/UserCenter/Order/MarketsRefund'], resolve)
        }
      },
      {
        path: 'evaluate/:id',
        name: 'marketsevaluate',
        component: resolve => {
          require(['@/modules/UserCenter/Order/Evaluate'], resolve)
        }
      }
    ],
    redirect: 'markets/marketsorders'
  },
  {
    path: 'account',
    name: 'account',
    component: resolve => {
      require(['@/modules/UserCenter/Account'], resolve)
    },
    children: [
      {
        path: 'profile',
        name: 'profile',
        component: resolve => {
          require(['@/modules/UserCenter/Account/Profile'], resolve)
        }
      },
      {
        path: 'profileH5',
        name: 'profileH5',
        component: resolve => {
          require(['@/modules/UserCenter/Account/ProfileH5'], resolve)
        }
      },
      {
        path: 'password',
        name: 'password',
        component: resolve => {
          require(['@/modules/UserCenter/Account/Password'], resolve)
        }
      },
      {
        path: 'address',
        name: 'address',
        component: resolve => {
          require(['@/modules/UserCenter/Account/Address'], resolve)
        }
      },
      {
        path: 'library',
        name: 'library',
        component: resolve => {
          require(['@/modules/UserCenter/Account/Library'], resolve)
        }
      },
      {
        path: 'security',
        name: 'security',
        component: resolve => {
          require(['@/modules/UserCenter/Account/Security'], resolve)
        }
      },
      {
        path: 'role',
        name: 'role',
        component: resolve => {
          require(['@/modules/UserCenter/Account/Role'], resolve)
        }
      }
    ],
    redirect: 'account/profile'
  },
  {
    path: 'sysManager',
    name: 'sysManager',
    component: resolve => {
      require(['@/modules/UserCenter/SysManager'], resolve)
    },
    children: [
      {
        path: 'userList',
        name: 'userList',
        component: resolve => {
          require(['@/modules/UserCenter/SysManager/userList'], resolve)
        }
      }
    ]
  },
  {
    path: 'invoicemanage',
    name: 'invoicemanage',
    component: resolve => {
      require(['@/modules/UserCenter/Invoice'], resolve)
    },
    children: [
      {
        path: 'invoicelist',
        name: 'invoicelist',
        component: resolve => {
          require(['@/modules/UserCenter/Invoice/InvoiceList'], resolve)
        }
      },
      {
        path: 'invoiceinfo',
        name: 'invoiceinfo',
        component: resolve => {
          require(['components/invoice/InvoiceInfo'], resolve)
        }
      }
    ]
  },
  {
    path: 'message',
    name: 'message',
    component: resolve => {
      require(['@/modules/UserCenter/Message'], resolve)
    },
    children: [
      {
        path: 'messages',
        name: 'messages',
        component: resolve => {
          require(['@/modules/UserCenter/Message/List'], resolve)
        }
      }
    ],
    redirect: 'message/messages'
  },
  {
    path: 'requirement',
    name: 'requirement',
    component: resolve => {
      require(['@/modules/UserCenter/Require'], resolve)
    },
    children: [
      {
        path: 'requires',
        name: 'requires',
        component: resolve => {
          require(['@/modules/UserCenter/Require/RequireList'], resolve)
        }
      }
    ],
    redirect: 'requirement/requires'
  }
]



// WEBPACK FOOTER //
// ./src/router/personal.js